import AutoReplenishmentHub from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentHub/AutoReplenishmentHub';

export default AutoReplenishmentHub;
